import React from "react";
import { Card } from "@chakra-ui/react";

import "../../Animations.css";
import { haptic } from "@/lib/haptic";
interface OnboardingCardProps {
  emoji: string | React.ReactNode;
  title: string;
  selected?: boolean;
  onClick?: () => void;
}

const OnboardingRectangleCard: React.FC<OnboardingCardProps> = ({
  emoji,
  title,
  selected = false,
  onClick,
}) => {
  const handleClick = () => {
    haptic.soft();
    onClick?.();
  };

  return (
    <Card
      direction={"row"}
      justifyContent={"start"}
      alignItems={"center"}
      rounded={"2xl"}
      width={"full"}
      height={"70px"}
      p={5}
      gap={4}
      color={"black"}
      bg={"white"}
      border={
        selected
          ? "2px solid var(--color-blue)"
          : "1px solid var(--color-grey-light)"
      }
      onClick={handleClick}
      className={`items-center w-full ${selected ? "press-animation" : ""}`}
    >
      <div className="text-3xl mb-1">{emoji}</div>
      <div className={`font-semibold text-base text-start`}>{title}</div>
    </Card>
  );
};

export default OnboardingRectangleCard;
